import { EventBus as _EventBus } from 'components/eventBus/EventBus';
import { ECommonEvent } from 'types/common';

import { ILogEventPayload } from './ILogger';

export const EventBus = new _EventBus<TLoggerEvents>();

export enum ELoggerEvents {
  LOG = 'logger.log',
}

export type TLoggerEvents = {
  [ELoggerEvents.LOG]: ILogEventPayload;
  [ECommonEvent.COMMON_ERROR]: any;
};
